import {
  DELETE_COLUMN,
  RESET_CONDITION_MODAL,
  SET_COLUMN_NAME_VALUE,
  SET_COLUMN_SCHEME,
  SET_CONDITION_VARIABLES,
  SET_CURRENT_SORTED_VALUE,
  SET_CURSOR_POSITION,
  SET_FUNCTION_VALUE,
  SET_NODE_LIST,
  SET_SHOW_DROPDOWN,
  SET_TREE,
} from "store/constans";
import { ObjectDeleteByKey } from "utils/helpers";
import { FormulaTree } from "utils/services";
import { v4 } from "uuid";

const conditionalButtons = [
  {
    name: "+",
    label: "+",
  },
  {
    name: "-",
    label: "-",
  },
  {
    name: "*",
    label: "*",
  },
  {
    name: "/",
    label: "/",
  },
  {
    name: "^",
    label: "^",
  },
  {
    name: "(",
    label: "(",
  },
  {
    name: ")",
    label: ")",
  },
  {
    name: "Min",
    label: "Min(",
  },
  {
    name: "Max",
    label: "Max(",
  },
  {
    name: "RoundUp",
    label: "RoundUp(",
  },
  {
    name: "RoundDown",
    label: "RoundDown(",
  },
  {
    name: "SubtractingDates",
    label: "SubtractingDates(",
  },
  {
    name: "π (PI)",
    label: "PI",
  },
];

const BaseFormulaSettings = {
  [FormulaTree.NODE_TYPES.Function]: {
    SubtractingDates: {
      key: v4(),
      name: "SubtractingDates",
      label: "SubtractingDates(",
      type: FormulaTree.NODE_TYPES.Function,
      argumentsCount: [1, 2],
      argumentsType: ["date"],
      nextNodeType: [
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
      ],
      nextValueType: [
        "number",
      ],
      returnValueType: "number",
      returnType: FormulaTree.NODE_TYPES.Value,
    },
    Min: {
      key: v4(),
      name: "Min",
      label: "Min(",
      type: FormulaTree.NODE_TYPES.Function,
      argumentsCount: [1, 2],
      argumentsType: ["number", "function"],
      nextNodeType: [
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      returnValueType: "number",
      returnType: FormulaTree.NODE_TYPES.Value,
    },
    Max: {
      key: v4(),
      name: "Max",
      label: "Max(",
      type: FormulaTree.NODE_TYPES.Function,
      argumentsCount: [1, 2],
      argumentsType: ["number", "function"],
      nextNodeType: [
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      returnValueType: "number",
      returnType: FormulaTree.NODE_TYPES.Value,
    },
    RoundUp: {
      key: v4(),
      name: "RoundUp",
      label: "RoundUp(",
      type: FormulaTree.NODE_TYPES.Function,
      argumentsCount: [1],
      argumentsType: ["number", "function"],
      nextNodeType: [
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      returnValueType: "number",
      returnType: FormulaTree.NODE_TYPES.Value,
    },
    RoundDown: {
      key: v4(),
      name: "RoundDown",
      label: "RoundDown(",
      type: FormulaTree.NODE_TYPES.Function,
      argumentsCount: [1],
      argumentsType: ["number", "function"],
      nextNodeType: [
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      returnValueType: "number",
      returnType: FormulaTree.NODE_TYPES.Value,
    },
    Round: {
      key: v4(),
      name: "Round",
      label: "Round(",
      type: FormulaTree.NODE_TYPES.Function,
      argumentsCount: [1],
      argumentsType: ["number", "function"],
      nextNodeType: [
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      returnValueType: "number",
      returnType: FormulaTree.NODE_TYPES.Value,
    },
  },
  [FormulaTree.NODE_TYPES.Variable]: {},
  [FormulaTree.NODE_TYPES.Constants]: {
    "π (PI)" : {
      key: v4(),
      name: 'π (PI)',
      label: 'PI',
      valueType: "number",
      nextNodeType: [FormulaTree.NODE_TYPES.Operator],
      type: FormulaTree.NODE_TYPES.Constants,
    }
  },
  [FormulaTree.NODE_TYPES.Operator]: {
    "+": {
      key: v4(),
      name: "+",
      label: "+",
      nextNodeType: [
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      nextValueType: [
        "number",
      ],
      type: FormulaTree.NODE_TYPES.Operator,
    },
    "-": {
      key: v4(),
      name: "-",
      label: "-",
      nextNodeType: [
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      nextValueType: [
        "number",
      ],
      type: FormulaTree.NODE_TYPES.Operator,
    },
    "*": {
      key: v4(),
      name: "*",
      label: "*",
      nextNodeType: [
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      nextValueType: [
        "number",
      ],
      type: FormulaTree.NODE_TYPES.Operator,
    },
    "/": {
      key: v4(),
      name: "/",
      label: "/",
      nextNodeType: [
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      nextValueType: [
        "number",
      ],
      type: FormulaTree.NODE_TYPES.Operator,
    },
    "^": {
      key: v4(),
      name: "^",
      label: "^",
      nextNodeType: [
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      nextValueType: [
        "number",
      ],
      type: FormulaTree.NODE_TYPES.Operator,
    },
  },
  [FormulaTree.NODE_TYPES.Brackets]: {
    Parentheses: {
      key: v4(),
      name: "( )",
      label: "(",
      type: FormulaTree.NODE_TYPES.Brackets,
      argumentsCount: [1],
      argumentsType: ["number", "function"],
      nextNodeType: [
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Constants,
        FormulaTree.NODE_TYPES.Brackets,
      ],
      returnValueType: "number",
      returnType: FormulaTree.NODE_TYPES.Value,
    },
  },
};

const initialOperators = [];
const initialVariables = [];
const initialFunctions = [];
const initialBrackets = [];
const initialConstants = []

for (const key in BaseFormulaSettings[FormulaTree.NODE_TYPES.Function]) {
  const currentFunction =
    BaseFormulaSettings[FormulaTree.NODE_TYPES.Function][key];
  initialFunctions.push(currentFunction);
}

for (const key in BaseFormulaSettings[FormulaTree.NODE_TYPES.Constants]) {
  const currentConstants = BaseFormulaSettings[FormulaTree.NODE_TYPES.Constants][key];
  initialConstants.push(currentConstants);
}

for (const key in BaseFormulaSettings[FormulaTree.NODE_TYPES.Operator]) {
  const currentSymbol =
    BaseFormulaSettings[FormulaTree.NODE_TYPES.Operator][key];
  initialOperators.push(currentSymbol);
}

for (const key in BaseFormulaSettings[FormulaTree.NODE_TYPES.Brackets]) {
  const currentBrackets =
    BaseFormulaSettings[FormulaTree.NODE_TYPES.Brackets][key];
  initialBrackets.push(currentBrackets);
}

const initState = {
  conditionVariables: [],
  dropdownData: {
    [FormulaTree.NODE_TYPES.Function]: initialFunctions,
    [FormulaTree.NODE_TYPES.Variable]: initialVariables,
    [FormulaTree.NODE_TYPES.Constants]: initialConstants,
    [FormulaTree.NODE_TYPES.Operator]: initialOperators,
    [FormulaTree.NODE_TYPES.Brackets]: initialBrackets,
  },
  conditionalButtons: conditionalButtons,
  currentSortedValue: null,
  currentTree: null,
  currentNodeList: [],
  showDropDown: false,
  currentPosition: 0,
  newColumnName: "",
  functionValue: "",
  columnSchemes: null,
};

const conditionReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case SET_CONDITION_VARIABLES: {
      return {
        ...state,
        conditionVariables: [...payload.conditionVariables],
        dropdownData: { ...state.dropdownData, ...payload.dropdownData },
      };
    }
    case SET_SHOW_DROPDOWN: {
      return { ...state, showDropdown: payload.showDropdown };
    }
    case SET_COLUMN_NAME_VALUE: {
      return { ...state, newColumnName: payload.newColumnName };
    }
    case SET_FUNCTION_VALUE: {
      return { ...state, functionValue: payload.functionValue };
    }
    case SET_CURRENT_SORTED_VALUE: {
      return { ...state, currentSortedValue: payload.currentSortedValue };
    }
    case SET_CURSOR_POSITION: {
      return { ...state, currentPosition: payload.currentPosition };
    }
    case SET_COLUMN_SCHEME: {
      
      if(payload.prevColumnName === payload.newColumnName) {
        return {
          ...state,
          columnSchemes: { ...state.columnSchemes, ...payload.columnSchemes },
        };
      }
      
      const filteredScheme = ObjectDeleteByKey({
        object: state.columnSchemes,
        keyToDelete: payload.prevColumnName
      })

      return {
          ...state,
          columnSchemes: { ...filteredScheme, ...payload.columnSchemes },
      };
    }
    case SET_TREE: {
      return {
        ...state,
        currentTree: payload.currentTree,
      };
    }
    case SET_NODE_LIST: {
      return {
        ...state,
        currentNodeList: payload.currentNodeList,
      };
    }
    case DELETE_COLUMN: {
      const newColumnScheme = ObjectDeleteByKey({
        object: state?.columnSchemes,
        keyToDelete: payload.columnName
      })
      return {
        ...state,
        columnSchemes: newColumnScheme,
      };
    }
    case RESET_CONDITION_MODAL: {
      return initState
    }
    default:
      return state;
  }
};
export default conditionReducer;
